import { StorageSerializers } from '@vueuse/core';
import type { Serializer } from '@vueuse/core';

export type SerializerType = keyof typeof StorageSerializers;
export type HandlerType = keyof Serializer<unknown>;

/**
 * 根据原始值获取类型
 * @param rawInit 原始值
 * @returns
 */
export const guessSerializerType: (rawInit: unknown) => SerializerType = (rawInit) => {
  return rawInit == null
    ? 'any'
    : rawInit instanceof Set
    ? 'set'
    : rawInit instanceof Map
    ? 'map'
    : rawInit instanceof Date
    ? 'date'
    : typeof rawInit === 'boolean'
    ? 'boolean'
    : typeof rawInit === 'string'
    ? 'string'
    : typeof rawInit === 'object'
    ? 'object'
    : !Number.isNaN(rawInit)
    ? 'number'
    : 'any';
};
/**
 * 获取一个值的对应序列化和反序列化的方法
 * @param handler serializer的处理方法
 * @param {rawInit} 要处理的值 根据这个值自动获取对应的类型
 */

export function useSerializer(
  handler: HandlerType,
  rawInit?: unknown,
): Serializer<any>[HandlerType];
export function useSerializer(handler: 'write', rawInit?: unknown): Serializer<any>['write'];
export function useSerializer(handler: 'read', rawInit?: unknown): Serializer<any>['read'];
export function useSerializer(handler: HandlerType, rawInit?: unknown) {
  return StorageSerializers[guessSerializerType(rawInit)][handler];
}
